import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import React, { PureComponent } from 'react';

import styles from './styles';

interface IProps {
  onSubmit?: Function;
  label?: string;
  helperText?: string;
  onChange?: Function;
  limits: number;
  minimum: number;
  value: any;
  error?: boolean;
  singleSpace?: boolean;
  classes: any;
  ref?: any;
  onFocus?: any;
  id?: any;
  disabled?: boolean;
  placeholder?: string;
}

interface IState {
  comment: string;
  remaining: number;
  progress: number;
  status: string;
  minimum: number;
}

class CharacterCounter extends PureComponent<IProps, IState> {
  private charactersLimit = this.props.limits;
  private characterMinimum = this.props.minimum;

  constructor(props: IProps) {
    super(props);

    this.state = {
      comment: '',
      progress: 0,
      remaining: this.charactersLimit,
      minimum: this.characterMinimum,
      status: 'none',
    };
  }

  handleChange = (e: any) => {
    const { onChange, singleSpace } = this.props;
    let { value } = e.target;

    const progress = value.length < this.charactersLimit ? (value.length * 100) / this.charactersLimit : 100;
    const remaining = this.charactersLimit - value.length;
    let status;
    if (singleSpace) {
      value = value.replace(/  +/g, ' ');
      e.target.value = value;
    }

    if ((value.length < this.charactersLimit && value.length > 0 && value.length < this.characterMinimum) || value.length >= this.charactersLimit) {
      status = 'finish';
    } else if (value.length === 0) {
      status = 'none';
    } else {
      status = 'success';
    }

    this.setState({
      comment: e.target.value,
      remaining,
      progress,
      status,
    });

    onChange(e);
  };

  componentDidMount() {
    const { value } = this.props;
    let progress = 0;
    let remaining = 0;
    let status = 'none';
    if (value) {
      progress = value.length < this.charactersLimit ? (value.length * 100) / this.charactersLimit : 100;
      remaining = this.charactersLimit - value.length;

      if ((value.length < this.charactersLimit && value.length > 0 && value.length < this.characterMinimum) || value.length >= this.charactersLimit) {
        status = 'finish';
      } else if (value.length === 0) {
        status = 'none';
      } else {
        status = 'success';
      }
    }

    this.setState({
      comment: value,
      remaining,
      progress,
      status,
    });
  }

  render() {
    const { classes, onFocus, id } = this.props;
    return (
      <div className={classes.commentFormClass}>
        <div className={classes.commentFormInputFieldClass}>
          <TextField
            id={id}
            multiline={true}
            fullWidth={true}
            error={this.props.error ? this.props.error : false}
            label={this.props.label}
            helperText={this.props.helperText}
            InputProps={{ rows: 3, disableUnderline: true, maxRows: 10 }}
            InputLabelProps={{ shrink: true }}
            placeholder={this.props.placeholder ? this.props.placeholder : ''}
            value={this.props.value}
            onChange={this.handleChange}
            onFocus={onFocus}
            disabled={this.props.disabled}
          />
        </div>
        <div className={classes.commentFormActionsContainerClass}>
          <div className={`${classes.commentFormActionsContainerCharacterLimitClass} ${this.state.status}`}>
            <CircularProgress
              className={`${classes.commentFormActionsContainerCharacterLimitCircularProgressBufferClass} ${this.state.status}`}
              variant='static'
              value={100}
              size={30}
            />
            <CircularProgress
              className={`${classes.commentFormActionsContainerCharacterLimitCircularProgressBufferClass} ${this.state.status}`}
              variant='static'
              value={this.state.progress}
              size={30}
            />
            <span className={`${classes.commentFormActionsContainerCharacterLimitCharacterCountClass} ${this.state.status}`}>
              {this.state.remaining}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default styles(CharacterCounter);
